<template>
  <section></section>
</template>

<script>
  export default {
    name: 'access',
    created () {
      this.$router.push('/')
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/Access.vue